import {Component, OnInit} from '@angular/core';
import {BaseComponent} from "../base.component";
import {Router} from "@angular/router";
import {BUILD} from '../../../../version';
import {AuthService} from "../auth/auth.service";


@Component({
    selector: 'template-footer',
    template: `
        <div class="footer-menu footer-navigation Wid100">
            <div class="Opac20 GrayBack" style="height: 3px;"></div>

            <!-- content -->
            <ng-content></ng-content>

            <div class="footer-navigation-items">
                <div class="footer-navigation-item">
                    <a (click)="router.navigate(['/orders'])" class="BoldGray">
                        <i class="pi pi-shopping-cart"></i>
                        <br/>
                        <span class="BsFsXXSmall">{{v('menu_orders')}}</span>
                    </a>
                </div>
                <div class="footer-navigation-item">
                    <a (click)="router.navigate(['/history'])" class="BoldGray">
                        <i class="pi pi-calendar"></i>
                        <br/>
                        <span class="BsFsXXSmall">{{v('menu_history')}}</span>
                    </a>
                </div>
                <div class="footer-navigation-item">
                    <a (click)="router.navigate(['/menuplans'])" class="BoldGray">
                        <i class="pi pi-book"></i>
                        <br/>
                        <span class="BsFsXXSmall">{{v('menu_menuplans')}}</span>
                    </a>
                </div>
                <div class="footer-navigation-item">
                    <a (click)="router.navigate(['/invoices'])" class="BoldGray">
                        <i class="pi pi-file-pdf"></i>
                        <br/>
                        <span class="BsFsXXSmall">{{v('menu_invoices')}}</span>
                    </a>
                </div>
                <div class="footer-navigation-item">
                    <a (click)="router.navigate(['/messages'])" class="BoldGray">
                        <span class="message-icon-container">
                            <i class="pi pi-envelope"></i>
                            <ng-container *ngIf="incomingMessages$ | async as incomingMessages">
                                <span *ngIf="incomingMessages > 0" class="message-count-badge">{{incomingMessages}}</span>
                            </ng-container>
                        </span>
                        <br/>
                        <span class="BsFsXXSmall">{{v('menu_messages')}}</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="footer-menu Wid100 TexAlRight HideOnMobile">
            <div class="DispInlBlock BsWid400p SoftGrayBack2 MarR Opac80" >BestellApp {{appVersion}}</div>
        </div>

    `

})
export class TemplateFooterComponent extends BaseComponent {

    appVersion?: string;

    /**
     * Constructor.
     * @param router
     */
    incomingMessages$ = this.authService.incomingMessages$;

    constructor(public router: Router, private authService: AuthService) {
        super();
    }

    ngOnInit(): void {
        this.appVersion = ""+ BUILD;
    }
}
